import { callService, callServiceWithAuth } from "../../services/services";
import { getRandomInt } from "../../utils/enums";
import { updateAlert } from "../alert/actions";
import { setAcceptanceState } from "./actions";

export const fibaPasswordCheck = (body) => {
  return async (dispatch) => {
    return await callService("fibaPasswordCheck", body, dispatch,body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1" && data.resultInfo) {
          return data;
        } else {
          throw data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return {errorExplanation:err};
      });
  };
};

export const fibaPasswordCheckWithAuth = (body,username,password) => {
  return async (dispatch) => {
    return await callServiceWithAuth("fibaPasswordCheckWithAuth", body, dispatch,body.externalId,username,password)
      .then((response) => {
        const data = response.data;
        if (data.result === "1" && data.resultInfo) {
          return data;
        } else {
          throw data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return {errorExplanation:err};
      });
  };
};

export const fibaKeyInfo = (body) => {
  return async (dispatch) => {
    return await callService("fibaKeyInfo", body, dispatch,body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          dispatch(
            setAcceptanceState({
              ...data,
              format: getFormat(data.fibaKeyLength),
              fibakodDigits: getRandomDigits(data.fibaKeyLength)
            })
          );
          return data;
        } else {
          throw data.errorExplanation;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return { nextStatus: false, result: "1", msg: err };
      });
  };
};

const getRandomDigits = (keyLength) => {
  if (keyLength === undefined || keyLength === null || keyLength == "0" || keyLength == "") {
    return;
  }
  const firstDigit = getRandomInt(0, keyLength - 1);
  let secondDigit = getRandomInt(0, keyLength - 1);

  while (firstDigit === secondDigit) {
    secondDigit = getRandomInt(0, keyLength - 1);
  }

  return {
    firstDigit : firstDigit<secondDigit ? firstDigit : secondDigit,
    secondDigit: firstDigit<secondDigit ? secondDigit : firstDigit,
  }

} 

const getFormat = (digit) => {
  let format = "";
  if (digit === undefined || digit === null || digit == "0" || digit == "") {
    return;
  }
  const firstDigit = getRandomInt(0, digit - 1);
  let secondDigit = getRandomInt(0, digit - 1);

  while (firstDigit === secondDigit) {
    secondDigit = getRandomInt(0, digit - 1);
  }

  for (let i = 0; i < digit; i++) {
    if (i === firstDigit || i === secondDigit) {
      format += "*";
    } else {
      format += "#";
    }
  }

  return format;
};
